import { FC } from 'react';
// Types
import { Dimension } from 'app/store/BillingUsage/BillingUsage.types';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectParams } from 'app/store/BillingUsage/BillingUsage.selectors';
// Mui
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Theme } from '@mui/material';
// Utilities
import { toNumberWithCommas } from 'app/utilities/Utilities';
// i18next
import { useTranslation } from 'react-i18next';

const UsageNoDataFound:FC = () => {
  const { t } = useTranslation();
  // State
  const params = useAppSelector(selectParams);

  const renderTableHeadRow = () => {
    switch (params.dimensions) {
      case Dimension.Case:
        return (
          <TableRow>
            <TableCell>{t('labels.caseName')}</TableCell>
            <TableCell sx={{ maxWidth: '50%' }}>{t('labels.invoices')}</TableCell>
            <TableCell>{t('labels.total')}</TableCell>
          </TableRow>
        );
      case Dimension.Service:
        return (
          <TableRow>
            <TableCell>{t('labels.serviceName')}</TableCell>
            <TableCell sx={{ maxWidth: '50%' }}>{t('labels.invoices')}</TableCell>
            <TableCell>{t('labels.qty')}</TableCell>
            <TableCell>{t('labels.total')}</TableCell>
          </TableRow>
        );
      default:
        return (
          <TableRow>
            <TableCell>{t('labels.caseName')}</TableCell>
            <TableCell sx={{ maxWidth: '50%' }}>{t('labels.invoices')}</TableCell>
            <TableCell>{t('labels.serviceName')}</TableCell>
            <TableCell>{t('labels.qty')}</TableCell>
            <TableCell>{t('labels.total')}</TableCell>
          </TableRow>
        );
    }
  };

  const colspan = params.dimensions === Dimension.Case
    ? 3
    : params.dimensions === Dimension.Service
      ? 4
      : 5
  ;

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table stickyHeader>
        <TableHead>
          {renderTableHeadRow()}
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={colspan}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                <span>{t('pages.billingAndSubscriptions.noDataFound')}</span>
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
        <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1 }}>
          <TableRow sx={{
            bgcolor: (theme:Theme) => theme.palette.grey[50],
            '& > td': {
              borderBottom: 0
            }
          }}>
            <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem' }} colSpan={colspan - 1}>{t('labels.total')}</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem' }}>{`$${toNumberWithCommas(0)}`}</TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default UsageNoDataFound